<template>
    <el-container class="layout-container">
      <!-- 左侧菜单 -->
      <el-aside width="200px" class="aside">
        <el-menu
          default-active="/"
          class="el-menu-vertical"
          background-color="#1a1a1a"
          text-color="#fff"
          active-text-color="#ffd04b"
          router
        >
          <el-menu-item index="/">
            <el-icon><HomeFilled /></el-icon>
            <span>首页</span>
          </el-menu-item>
          <el-menu-item index="/text">
            <el-icon><Document /></el-icon>
            <span>文本生成</span>
          </el-menu-item>
          <el-menu-item index="/image">
            <el-icon><Picture /></el-icon>
            <span>图片生成</span>
          </el-menu-item>
          <el-menu-item index="/video">
            <el-icon><VideoCamera /></el-icon>
            <span>视频生成</span>
          </el-menu-item>
          <el-menu-item index="/square">
            <el-icon><Grid /></el-icon>
            <span>广场</span>
          </el-menu-item>
          <el-menu-item index="/vip">
            <el-icon><Grid /></el-icon>
            <span>套餐升级</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
  
      <el-container>
        <!-- 顶部栏 -->
        <el-header class="header">
          <div class="header-title">AI 内容生成器</div>
          <div class="user-info">
            <el-avatar :size="32" :src="userStore.avatar" />
            <el-dropdown>
              <span class="el-dropdown-link">
                {{ userStore.username }}
                <el-icon class="el-icon--right">
                  <arrow-down />
                </el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
  
        <!-- 主要内容区域 -->
        <el-main class="main-content">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </template>
  
  <script setup>
  import { HomeFilled, Document, Picture, VideoCamera, Grid, ArrowDown } from '@element-plus/icons-vue'
  import { useUserStore } from '@/stores/user'
  import { useRouter } from 'vue-router'
  import userApi from '@/api/userApi.js'
  const userStore = useUserStore()
  const router = useRouter()
  
  const logout = () => {
    userApi.logout().then((r)=>{
      if (r.code == 200) {
        userStore.logout()
        router.push('/login')
      }
    })
  }
  </script>
  
  <style scoped>
  .layout-container {
    height: 100vh;
    background-color: #121212;
    color: #ffffff;
  }
  
  .aside {
    background-color: #1a1a1a;
  }
  
  .header {
    background-color: #1a1a1a;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }
  
  .header-title {
    font-size: 1.2rem;
    font-weight: bold;
  }
  
  .user-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #ffffff;
    display: flex;
    align-items: center;
  }
  
  .main-content {
    background-color: #121212;
    position: relative;
    overflow: hidden;
  }
  
  /* 星星背景 */
  .main-content::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: 
      radial-gradient(2px 2px at 20px 30px, #eee, rgba(0,0,0,0)),
      radial-gradient(2px 2px at 40px 70px, #fff, rgba(0,0,0,0)),
      radial-gradient(2px 2px at 50px 160px, #ddd, rgba(0,0,0,0)),
      radial-gradient(2px 2px at 90px 40px, #fff, rgba(0,0,0,0)),
      radial-gradient(2px 2px at 130px 80px, #fff, rgba(0,0,0,0)),
      radial-gradient(2px 2px at 160px 120px, #ddd, rgba(0,0,0,0));
    background-repeat: repeat;
    background-size: 200px 200px;
    animation: twinkle 4s infinite;
    opacity: 0.2;
    z-index: 1;
  }
  
  @keyframes twinkle {
    0% { transform: translateY(0); }
    100% { transform: translateY(-200px); }
  }
  
  .el-main {
    position: relative;
    z-index: 2;
  }
  </style>